import { createAsyncThunk } from "@reduxjs/toolkit";
import { getToken as getTokenApi } from "../../helpers/api_helper";

export const getToken = createAsyncThunk("token/getToken", async (credentials) => {
    try {
        const response = await getTokenApi(credentials);
        return response.token;
    } catch (error) {
        return error;
    }
});